import JobWorkerNotInterestedReason from "@/models/JobWorkers/JobWorkerNotInterestedReason";
import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateJobWorkerStatusWorkerInterestedRequest extends BaseUpdateRequest  { 
    jobWorkerId = '';
    interested = false;
    notInterestedReason: JobWorkerNotInterestedReason = 0;
}
